<div class="calendar-nav">
    <div class="row no-gutters text-center">
        <div class="col text-left">
            <div class="w-100 padding-side-20">
                @for (age of calendarData.ages; track age) {
                    <div class="form-check form-check-inline">
                        <input
                            (change)="onChangeSelectedAge()"
                            [(ngModel)]="age.isSelected"
                            class="form-check-input"
                            type="checkbox"
                            id="{{ age.ageRangeFromInMonths }}_{{
                                age.ageRangeToInMonts
                            }}"
                        />
                        <label
                            class="form-check-label main-green bolded"
                            for="{{ age.ageRangeFromInMonths }}_{{
                                age.ageRangeToInMonts
                            }}"
                            >{{ age.ageRangeFromInMonths | age }} -
                            {{ age.ageRangeToInMonths | age }}</label
                        >
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="row no-gutters text-center voffset-10">
        <div class="col-md-auto min-width-100 hand" (click)="onPreviousWeek()">
            <div class="fa fa-chevron-left" aria-hidden="true"></div>
        </div>
        <div class="col size-16">
            {{ firstDay.date | bcDate }} - {{ lastDay.date | bcDate }}
        </div>
        <div class="col-md-auto min-width-100 hand" (click)="onNextWeek()">
            <div class="fa fa-chevron-right" aria-hidden="true"></div>
        </div>
    </div>
</div>
